var _metadata, _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, "image/svg+xml")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-9.75,133.5l391.6,0l0,-112.5l-391.6,0l0,112.5z",
    id: "path16"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 102,
    width: 502,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,150) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4cc8ef",
    fillRule: "nonzero",
    d: "m65.75,47l-17.2,53.2c-0.8,2.4 1,4.8 3.5,4.8l33.1,0c2.5,0 4.3,-2.4 3.5,-4.8l-17.3,-53.2c-0.9,-2.6 -4.7,-2.6 -5.6,0",
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4cc8ef",
    fillRule: "nonzero",
    d: "m25.350101,47l-17.3,53.2c-0.8,2.4 1,4.8 3.5,4.8l33.1,0c2.5,0 4.3,-2.4 3.5,-4.8l-17.3,-53.2c-0.8,-2.6 -4.6,-2.6 -5.5,0",
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "m162.549805,105.200203l-33.6,0c-2.7,0 -5,-2.2 -5,-5l0,-51.7c0,-1.901 1.4,-3.6 3.4,-3.7c2.1,-0.1 3.8,1.5 3.8,3.6l0,21.699l15.5,0c1.6,0 3.1,1.201 3.3,2.801c0.2,1.9 -1.3,3.5 -3.1,3.5l-15.6,0l0,22.5l31.2,0c1.6,0 3.1,1.2 3.3,2.8c0.2,1.9 -1.3,3.5 -3.2,3.5",
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "m208.450195,51.0996l-26.5,0l0,50.4c0,1.9 -1.4,3.6 -3.4,3.701c-2.1,0.099 -3.8,-1.5 -3.8,-3.601l0,-50.899c0,-3.201 2.6,-5.901 5.9,-5.901l27.6,0c1.599,0 3.099,1.2 3.3,2.8c0.2,1.9 -1.3,3.5 -3.1,3.5",
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "m270.049805,75c0,-4.5 -1.1,-8.7 -3.2,-12.4c-2.1,-3.7 -5.1,-6.6 -8.8,-8.7c-3.7,-2.1 -7.899,-3.1 -12.5,-3.1c-4.6,0 -8.8,1.1 -12.6,3.1c-3.7,2.1 -6.7,5 -8.799,8.7c-2.101,3.7 -3.201,7.9 -3.201,12.4c0,4.5 1.1,8.7 3.201,12.4c2.099,3.7 5.099,6.6 8.799,8.7c3.701,2.1 8,3.1 12.6,3.1c4.601,0 8.8,-1.1 12.5,-3.1c3.7,-2.1 6.7,-5 8.8,-8.7c2.1,-3.7 3.2,-7.8 3.2,-12.4m-8.3,26.7c-4.8,2.6 -10.2,4 -16.099,4c-5.901,0 -11.401,-1.3 -16.201,-4c-4.799,-2.7 -8.7,-6.4 -11.4,-11c-2.7,-4.6 -4.1,-9.9 -4.1,-15.7c0,-5.8 1.4,-11.1 4.1,-15.7c2.7,-4.6 6.5,-8.3 11.4,-11c4.8,-2.7 10.3,-4 16.201,-4c5.899,0 11.399,1.3 16.099,4c4.8,2.6 8.6,6.3 11.3,11c2.7,4.7 4.101,10 4.101,15.7c0,5.8 -1.401,11.1 -4.101,15.7c-2.7,4.7 -6.5,8.4 -11.3,11",
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "m367.450195,103.799797c-0.601,0.9 -1.601,1.4 -2.7,1.4c-1.401,0 -2.7,-0.9 -3.1,-2.2l-16.2,-47.8c0,-0.1 -0.101,-0.1 -0.101,-0.1c-0.099,0 -0.099,0 -0.099,0.1l-16,47c-0.6,1.8 -2.401,3.1 -4.3,3.1c-1.9,0 -3.7,-1.2 -4.3,-3.1l-16.4,-46.799c0,-0.101 -0.1,-0.101 -0.1,-0.101c-0.1,0 -0.1,0 -0.1,0.101l-15.8,47.199c-0.5,1.6 -2,2.6 -3.7,2.6c-1.1,0 -2.1,-0.5 -2.701,-1.4c-0.599,-0.9 -0.799,-2 -0.399,-3l17.7,-52.6c0.699,-2 2.6,-3.4 4.699,-3.4c2.101,0 4,1.4 4.701,3.4l15.9,46c0,0.1 0.1,0.1 0.2,0.1c0,0 0.1,0 0.199,-0.1l15.801,-46c0.699,-2 2.6,-3.4 4.8,-3.4c2.2,0 4.1,1.4 4.8,3.4l17.7,52.6c0.3,1.1 0.1,2.1 -0.5,3",
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111111",
    fillRule: "nonzero",
    d: "m86.049797,47l-17.3,53.2c-0.8,2.4 1,4.8 3.5,4.8l33.1,0c2.5,0 4.3,-2.4 3.5,-4.8l-17.3,-53.1c-0.8,-2.7 -4.7,-2.7 -5.5,-0.1",
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111111",
    fillRule: "nonzero",
    d: "m45.549801,47l-17.3,53.2c-0.8,2.4 1,4.8 3.5,4.8l33.1,0c2.5,0 4.3,-2.4 3.5,-4.8l-17.2,-53.2c-0.9,-2.6 -4.7,-2.6 -5.6,0",
    id: "path50"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFlow);
export default __webpack_public_path__ + "static/media/logo-flow.92c1e4f247ad0697a9d9d57175e1f641.svg";
export { ForwardRef as ReactComponent };